<template>
  <v-select @change="onChangeAge" :label="labelName" :items="ages"> </v-select>
</template>

<script>
export default {
  props: ["labelName"],

  data() {
    return {
      ages: []
    };
  },
  created() {
    for (let i = 5; i < 100; i++) {
      this.ages.push(i);
    }
  },
  methods: {
    onChangeAge(val) {
      this.$emit("age", val);
    }
  }
};
</script>

<style>
.select_age {
  margin-top: 22px;
}
</style>
